import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useCallback,
  useState,
} from 'react';
import ImageCropModal from '../../../../components/imageCropModal';
import ImageUploadBox from './ImageUploadBox';

interface IProps {
  setUploadedImage: Dispatch<SetStateAction<File | null>>;
  uploadedImage: File | null;
  classname?: string;
  title?: string;
}

const ReceiptImageUpload = ({
  uploadedImage,
  setUploadedImage,
  classname = '',
  title = 'ارسال تصویر رسید',
}: IProps) => {
  const [showCropModal, setShowCropModal] = useState(false);
  const [currentImage, setCurrentImage] = useState<File | null>(null);

  // Image handling
  const handleCropComplete = useCallback((croppedImage: File) => {
    setUploadedImage(croppedImage);
    setShowCropModal(false);
  }, []);

  const handleImageChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setCurrentImage(file);
    setShowCropModal(true);
    e.target.value = '';
  }, []);

  const removeCroppedImage = useCallback(() => {
    setUploadedImage(null);
  }, []);

  return (
    <div className={classname}>
      <p className="text-sm font-medium text-gray-900">
        {title} <span className="text-red-600 text-md">*</span>
      </p>

      {/* Uploaded image thumbnail */}
      <ImageUploadBox
        variant="sm"
        croppedImageFile={uploadedImage}
        onImageRemove={removeCroppedImage}
        onImageChange={handleImageChange}
      />

      {/* Image cropped modal */}
      {showCropModal && currentImage && (
        <ImageCropModal
          originalFile={currentImage}
          onComplete={handleCropComplete}
          onClose={() => setShowCropModal(false)}
        />
      )}
    </div>
  );
};

export default ReceiptImageUpload;
